import { render, staticRenderFns } from "./literacyEvaluation.vue?vue&type=template&id=3f4f7289&scoped=true"
import script from "./literacyEvaluation.vue?vue&type=script&lang=js"
export * from "./literacyEvaluation.vue?vue&type=script&lang=js"
import style0 from "./literacyEvaluation.vue?vue&type=style&index=0&id=3f4f7289&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f7289",
  null
  
)

export default component.exports